'use client';
import { __awaiter } from 'tslib';
import localforage from 'localforage';
import { useState, useEffect } from 'react';

function useForageItem(key, isValid, defaultValue, onLoad) {
    const [isLoading, setIsLoading] = useState(true);
    const [item, setItem] = useState(defaultValue);
    function init() {
        return __awaiter(this, void 0, void 0, function* () {
            const item = yield localforage.getItem(key);
            if (isValid(item))
                setItem(item);
            setIsLoading(false);
            onLoad === null || onLoad === void 0 ? void 0 : onLoad(item);
            return item;
        });
    }
    useEffect(() => {
        init();
    }, []);
    function set(value) {
        let v = (typeof value === 'function') ? value = value(item) : value;
        if (!isValid(v))
            throw new Error("invalid set value");
        localforage.setItem(key, v);
        setItem(v);
    }
    return {
        isLoading,
        item,
        set,
        resync: init
    };
}
function getForageItem(key, isValid, defaultValue) {
    return __awaiter(this, void 0, void 0, function* () {
        let item = yield localforage.getItem(key);
        if (!isValid(item)) {
            localforage.setItem(key, defaultValue);
            item = defaultValue;
        }
        return item;
    });
}

export { getForageItem, useForageItem };
